module.exports = __webpack_public_path__ + "img/Integral-dark.2bcc9ef5.svg";